export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
};

export enum AccessType {
  Authorised = 'AUTHORISED',
  IncorrectAdvertiser = 'INCORRECT_ADVERTISER',
  NotFound = 'NOT_FOUND',
  Unauthorised = 'UNAUTHORISED',
}

export type AdvertiserJobAccess = {
  __typename?: 'AdvertiserJobAccess';
  accessType: AccessType;
  correctAdvertiserId?: Maybe<Scalars['ID']['output']>;
  correctAdvertiserName?: Maybe<Scalars['String']['output']>;
};

export type AhpraRegistration = {
  __typename?: 'AhpraRegistration';
  fullName?: Maybe<Scalars['String']['output']>;
  registration: Registration;
  type: Scalars['String']['output'];
  verification: CredentialVerification;
};

export type Attachment = {
  __typename?: 'Attachment';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPdf: Scalars['Boolean']['output'];
  type: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
};

export type Auth = {
  __typename?: 'Auth';
  xsrfToken: Scalars['String']['output'];
};

export type BaseCredential = {
  __typename?: 'BaseCredential';
  credentialInfo: Array<CredentialInfo>;
};

export enum BillableStatus {
  Billable = 'BILLABLE',
  NotBillable = 'NOT_BILLABLE',
}

export enum Bucket {
  Accept = 'ACCEPT',
  Inbox = 'INBOX',
  Interview = 'INTERVIEW',
  NotSuitable = 'NOT_SUITABLE',
  Offer = 'OFFER',
  Prescreen = 'PRESCREEN',
  Shortlist = 'SHORTLIST',
}

export type BucketCounts = {
  __typename?: 'BucketCounts';
  acceptCount: Scalars['Int']['output'];
  inboxCount: Scalars['Int']['output'];
  interviewCount: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  notSuitableCount: Scalars['Int']['output'];
  offerCount: Scalars['Int']['output'];
  prescreenCount: Scalars['Int']['output'];
  shortlistCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  viewedCount: Scalars['Int']['output'];
};

export type BulkProspectEmailPayload = {
  __typename?: 'BulkProspectEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type CmSearchRolloutSettings = {
  __typename?: 'CMSearchRolloutSettings';
  jobIdThreshold?: Maybe<Scalars['Int']['output']>;
  rolloutPercentage?: Maybe<Scalars['Int']['output']>;
};

export type Candidate = {
  __typename?: 'Candidate';
  prospects: Array<Prospect>;
};

export type CandidateDetails = {
  __typename?: 'CandidateDetails';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isNewToWorkforce?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mostRecentCompanyName?: Maybe<Scalars['String']['output']>;
  mostRecentJobTitle?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  previousCoverLetter?: Maybe<PreviousAttachment>;
  previousResume?: Maybe<PreviousAttachment>;
  timeInRoleMonths?: Maybe<Scalars['String']['output']>;
  timeInRoleYears?: Maybe<Scalars['String']['output']>;
};

export type CandidateId = {
  candidateId: Scalars['ID']['input'];
  prospectId: Scalars['ID']['input'];
};

export type CandidatePayload = {
  __typename?: 'CandidatePayload';
  node: Candidate;
};

export type CandidatePreviousApps = {
  __typename?: 'CandidatePreviousApps';
  candidateDetails?: Maybe<CandidateDetails>;
  mostRecentApplication?: Maybe<MostRecentApplication>;
};

export type CourseDetails = {
  __typename?: 'CourseDetails';
  courseName?: Maybe<Scalars['String']['output']>;
  honours?: Maybe<Scalars['String']['output']>;
  majors?: Maybe<Array<Scalars['String']['output']>>;
};

export type CovidVaccineCredential = {
  __typename?: 'CovidVaccineCredential';
  fullName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  verification: CredentialVerification;
};

export type CredentialInfo = {
  __typename?: 'CredentialInfo';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CredentialVerification = {
  __typename?: 'CredentialVerification';
  document?: Maybe<Scalars['String']['output']>;
  level: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  verifiedAt: Scalars['DateTime']['output'];
};

export type DeleteProspectAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  prospectId: Scalars['ID']['input'];
};

export type DeleteProspectAttachmentPayload = {
  __typename?: 'DeleteProspectAttachmentPayload';
  success: Scalars['Boolean']['output'];
};

export type DriversLicenceCredential = {
  __typename?: 'DriversLicenceCredential';
  fullName?: Maybe<Scalars['String']['output']>;
  licenceExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  verification?: Maybe<CredentialVerification>;
};

export type Education = {
  __typename?: 'Education';
  completed: Scalars['Boolean']['output'];
  completionDate?: Maybe<EducationCompletionDate>;
  credential?: Maybe<BaseCredential>;
  highlights?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institute: ProfileTextObject;
  name: ProfileTextObject;
};

export type EducationCompletionDate = {
  __typename?: 'EducationCompletionDate';
  month?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type ExpectedSalary = {
  __typename?: 'ExpectedSalary';
  currency?: Maybe<Scalars['String']['output']>;
  maximumSalaryValue?: Maybe<Scalars['Float']['output']>;
  minimumSalaryValue?: Maybe<Scalars['Float']['output']>;
  salaryType?: Maybe<SalaryType>;
};

export type FilterCounts = {
  __typename?: 'FilterCounts';
  rrFilterCounts?: Maybe<Array<Maybe<RoleRequirementFilterCount>>>;
};

export enum FilterOperator {
  And = 'AND',
  Or = 'OR',
}

export type Job = {
  __typename?: 'Job';
  jobInformation?: Maybe<JobInformation>;
};

export type JobApplicationStatus = {
  __typename?: 'JobApplicationStatus';
  status?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type JobApplicationSummariesByPositionIdInput = {
  /** seek web advertiser id */
  advertiserId: Scalars['ID']['input'];
  bucket?: InputMaybe<Bucket>;
  filters?: InputMaybe<ProspectFilters>;
  positionId: Scalars['ID']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type JobApplicationSummariesPayload = {
  __typename?: 'JobApplicationSummariesPayload';
  nodes: Array<Maybe<JobApplicationSummary>>;
};

export type JobApplicationSummary = {
  __typename?: 'JobApplicationSummary';
  adcentreProspectId: Scalars['ID']['output'];
  applicationCorrelationId: Scalars['ID']['output'];
  candidateFirstname: Scalars['String']['output'];
  candidateLastname: Scalars['String']['output'];
  status: JobApplicationStatus;
};

export type JobInformation = {
  __typename?: 'JobInformation';
  adType: Scalars['String']['output'];
  canExtendAd: Scalars['Boolean']['output'];
  classification: Scalars['String']['output'];
  expiredDate?: Maybe<Scalars['String']['output']>;
  internalReference?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['Int']['output']>;
  jobSource?: Maybe<Scalars['String']['output']>;
  listingId: Scalars['ID']['output'];
  /**
   * The date the listing was searchable and visible to candidates.
   * This date may be later than the \`positionCreatedDate\` e.g. when extending a job.
   */
  listingStartedDate: Scalars['String']['output'];
  listingStatus: Scalars['String']['output'];
  numberOfDaysRemaining?: Maybe<Scalars['Int']['output']>;
  /**
   * The date the position was created.
   * This date may be earlier than the \`listingStartedDate\`
   */
  positionCreatedDate: Scalars['String']['output'];
  positionId: Scalars['ID']['output'];
  postedBy: Scalars['String']['output'];
  questionnaireId?: Maybe<Scalars['String']['output']>;
  salary: Scalars['String']['output'];
  subClassification: Scalars['String']['output'];
  title: Scalars['String']['output'];
  workType: Scalars['String']['output'];
};

export type Licence = {
  __typename?: 'Licence';
  credential?: Maybe<BaseCredential>;
  description?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<MonthYear>;
  formattedExpiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issueDate?: Maybe<MonthYear>;
  issuingOrganisation?: Maybe<Scalars['String']['output']>;
  name: ProfileTextObject;
  noExpiryDate: Scalars['Boolean']['output'];
  origin: Scalars['String']['output'];
};

export type MatchedQualities = {
  __typename?: 'MatchedQualities';
  hasError: Scalars['Boolean']['output'];
  qualities?: Maybe<Array<MatchedQuality>>;
};

export type MatchedQuality = {
  __typename?: 'MatchedQuality';
  displayLabel: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isTop: Scalars['Boolean']['output'];
  relevanceScore: Scalars['Float']['output'];
};

export type MonthYear = {
  __typename?: 'MonthYear';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type MostRecentApplication = {
  __typename?: 'MostRecentApplication';
  alreadyAppliedForThisPosition: Scalars['Boolean']['output'];
  dateApplied: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createProspectNote: ProspectNote;
  deleteProspectAttachment: DeleteProspectAttachmentPayload;
  removeProspectNote: ProspectNote;
  sendBulkProspectEmail: BulkProspectEmailPayload;
  sendProspectEmail: ProspectEmail;
  updateStatusForProspectsWithContext: UpdateStatusForProspectsPayload;
};

export type MutationCreateProspectNoteArgs = {
  content: Scalars['String']['input'];
  prospectId: Scalars['ID']['input'];
};

export type MutationDeleteProspectAttachmentArgs = {
  input: DeleteProspectAttachmentInput;
};

export type MutationRemoveProspectNoteArgs = {
  noteId: Scalars['ID']['input'];
  prospectId: Scalars['ID']['input'];
};

export type MutationSendBulkProspectEmailArgs = {
  input: SendBulkProspectEmailInput;
};

export type MutationSendProspectEmailArgs = {
  enableReplies: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  prospectId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export type MutationUpdateStatusForProspectsWithContextArgs = {
  input: UpdateStatusForProspectsWithContextInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  preFilterTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PoliceCheckCredential = {
  __typename?: 'PoliceCheckCredential';
  fullName?: Maybe<Scalars['String']['output']>;
  metadata: PoliceCheckMetadata;
  type: Scalars['String']['output'];
  verification: CredentialVerification;
};

export type PoliceCheckMetadata = {
  __typename?: 'PoliceCheckMetadata';
  type?: Maybe<Scalars['String']['output']>;
};

export type PositionSummary = {
  __typename?: 'PositionSummary';
  hasAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PreviousAttachment = {
  __typename?: 'PreviousAttachment';
  attachmentId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  prospectId: Scalars['ID']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  education: Array<Education>;
  expectedSalaries: Array<ExpectedSalary>;
  licences: Array<Licence>;
  rightsToWork: Array<RightToWork>;
  skills: Array<Skill>;
  workHistory: Array<WorkHistory>;
};

export type ProfileTextObject = {
  __typename?: 'ProfileTextObject';
  text: Scalars['String']['output'];
};

export type Prospect = {
  __typename?: 'Prospect';
  appliedDate?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  billableStatus?: Maybe<BillableStatus>;
  bucket?: Maybe<Bucket>;
  candidateId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailCount?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  jobApplicationId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  matchedQualities: MatchedQualities;
  mostRecentCompanyName?: Maybe<Scalars['String']['output']>;
  mostRecentJobTitle?: Maybe<Scalars['String']['output']>;
  mostRecentRoleMonths?: Maybe<Scalars['Int']['output']>;
  noteCount?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  positionSummary?: Maybe<PositionSummary>;
  profile?: Maybe<Profile>;
  prospectCount?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<ProspectRating>;
  roleRequirements?: Maybe<Array<Maybe<RoleRequirement>>>;
  seekCandidateId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submission?: Maybe<SubmissionResult>;
  verifications: Array<Verification>;
};

export type ProspectAttachment = {
  __typename?: 'ProspectAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPdf: Scalars['Boolean']['output'];
  type: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
  uploadedDate?: Maybe<Scalars['String']['output']>;
  uploadedUser?: Maybe<Scalars['String']['output']>;
};

export type ProspectAttachments = {
  __typename?: 'ProspectAttachments';
  nodes: Array<ProspectAttachment>;
};

export type ProspectByAdcentreProspectIdInput = {
  adcentreProspectId: Scalars['ID']['input'];
  advertiserId: Scalars['ID']['input'];
  positionId: Scalars['ID']['input'];
};

export type ProspectData = {
  positionInList?: InputMaybe<Scalars['Int']['input']>;
  prospectId: Scalars['ID']['input'];
};

export type ProspectEmail = {
  __typename?: 'ProspectEmail';
  candidateId: Scalars['Int']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  prospectId: Scalars['Int']['output'];
  sentDate: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type ProspectEmails = {
  __typename?: 'ProspectEmails';
  nodes: Array<ProspectEmail>;
};

export type ProspectFilters = {
  rrFilters?: InputMaybe<Array<InputMaybe<RoleRequirementFilter>>>;
  rrGlobalFilters?: InputMaybe<Array<RoleRequirementFilter>>;
};

export type ProspectNote = {
  __typename?: 'ProspectNote';
  content?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  createdUser?: Maybe<Scalars['String']['output']>;
  createdUserId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
};

export type ProspectNotes = {
  __typename?: 'ProspectNotes';
  nodes: Array<ProspectNote>;
};

export type ProspectRating = {
  __typename?: 'ProspectRating';
  lastRatedDate?: Maybe<Scalars['String']['output']>;
  ratedByName?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

export type Prospects = {
  __typename?: 'Prospects';
  nodes: Array<Maybe<Prospect>>;
};

export type ProspectsByIdsFilter = {
  candidateId: Scalars['String']['input'];
  prospectId: Scalars['ID']['input'];
};

export type ProspectsWithPaginationByJobIdInput = {
  advertiserId: Scalars['ID']['input'];
  bucket?: InputMaybe<Bucket>;
  filters?: InputMaybe<ProspectFilters>;
  jobId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProspectsWithPaginationPayload = {
  __typename?: 'ProspectsWithPaginationPayload';
  bucketCounts?: Maybe<BucketCounts>;
  filterCounts?: Maybe<FilterCounts>;
  nodes: Array<Maybe<Prospect>>;
  pageInfo: PageInfo;
};

export type QualificationCredential = {
  __typename?: 'QualificationCredential';
  fullName?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<QualificationCredentialMetadata>;
  type: Scalars['String']['output'];
  verification: CredentialVerification;
};

export type QualificationCredentialMetadata = {
  __typename?: 'QualificationCredentialMetadata';
  conferralYear?: Maybe<Scalars['String']['output']>;
  courseDetails?: Maybe<CourseDetails>;
  educationProvider?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  advertiserJobAccessByJobId: AdvertiserJobAccess;
  advertiserJobAccessByPositionId: AdvertiserJobAccess;
  auth?: Maybe<Auth>;
  candidateById: CandidatePayload;
  candidatePreviousAppsByEmail: CandidatePreviousApps;
  cmSearchRolloutSettings: CmSearchRolloutSettings;
  job?: Maybe<Job>;
  jobApplicationSummariesByPositionId: JobApplicationSummariesPayload;
  jobByJobId?: Maybe<Job>;
  prospectAttachments: ProspectAttachments;
  prospectByAdcentreProspectId?: Maybe<Prospect>;
  prospectEmails: ProspectEmails;
  prospectNotes: ProspectNotes;
  prospectsWithPaginationByJobId: ProspectsWithPaginationPayload;
  version?: Maybe<Scalars['String']['output']>;
};

export type QueryAdvertiserJobAccessByJobIdArgs = {
  advertiserId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};

export type QueryAdvertiserJobAccessByPositionIdArgs = {
  advertiserId: Scalars['ID']['input'];
  positionId: Scalars['ID']['input'];
};

export type QueryCandidateByIdArgs = {
  id: CandidateId;
};

export type QueryCandidatePreviousAppsByEmailArgs = {
  email: Scalars['String']['input'];
  positionId: Scalars['ID']['input'];
};

export type QueryJobArgs = {
  advertiserId?: InputMaybe<Scalars['ID']['input']>;
  positionId: Scalars['ID']['input'];
};

export type QueryJobApplicationSummariesByPositionIdArgs = {
  input: JobApplicationSummariesByPositionIdInput;
};

export type QueryJobByJobIdArgs = {
  advertiserId?: InputMaybe<Scalars['ID']['input']>;
  jobId: Scalars['ID']['input'];
};

export type QueryProspectAttachmentsArgs = {
  prospectId: Scalars['ID']['input'];
};

export type QueryProspectByAdcentreProspectIdArgs = {
  input: ProspectByAdcentreProspectIdInput;
};

export type QueryProspectEmailsArgs = {
  candidateId: Scalars['ID']['input'];
  prospectId: Scalars['ID']['input'];
};

export type QueryProspectNotesArgs = {
  prospectId: Scalars['ID']['input'];
};

export type QueryProspectsWithPaginationByJobIdArgs = {
  input: ProspectsWithPaginationByJobIdInput;
};

export type Registration = {
  __typename?: 'Registration';
  division?: Maybe<Scalars['String']['output']>;
  divisions?: Maybe<Array<Scalars['String']['output']>>;
  expiryDate: Scalars['String']['output'];
  fieldOfSpecialty?: Maybe<Scalars['String']['output']>;
  profession: Scalars['String']['output'];
  specialties?: Maybe<Array<Scalars['String']['output']>>;
  specialty?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type RightToWork = {
  __typename?: 'RightToWork';
  answer: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type RightToWorkCredential = {
  __typename?: 'RightToWorkCredential';
  fullName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  verification: CredentialVerification;
};

export type RoleRequirement = {
  __typename?: 'RoleRequirement';
  answerType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use rrAnswers instead */
  answers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalId?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['String']['output'];
  rrAnswers: Array<RoleRequirementAnswer>;
  score?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<RoleRequirementStatus>;
  verifications: Array<Verification>;
};

export type RoleRequirementAnswer = {
  __typename?: 'RoleRequirementAnswer';
  globalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type RoleRequirementFilter = {
  answerIds: Array<InputMaybe<Scalars['String']['input']>>;
  operator: FilterOperator;
  questionId: Scalars['String']['input'];
};

export type RoleRequirementFilterCount = {
  __typename?: 'RoleRequirementFilterCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
};

export enum RoleRequirementStatus {
  Certified = 'CERTIFIED',
  Custom = 'CUSTOM',
  Match = 'MATCH',
  Neutral = 'NEUTRAL',
  NoMatch = 'NO_MATCH',
}

export enum SalaryType {
  Annually = 'ANNUALLY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
}

export type SendBulkProspectEmailInput = {
  enableReplies: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  prospectIds: Array<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
};

export type Skill = {
  __typename?: 'Skill';
  keyword?: Maybe<ProfileTextObject>;
};

export type SkillCredential = {
  __typename?: 'SkillCredential';
  type: Scalars['String']['output'];
  verification: CredentialVerification;
};

export enum Sort {
  ApplicationDate = 'APPLICATION_DATE',
  Name = 'NAME',
  Rating = 'RATING',
  Relevance = 'RELEVANCE',
  Score = 'SCORE',
  SearchRelevance = 'SEARCH_RELEVANCE',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Submission = {
  __typename?: 'Submission';
  roleRequirements?: Maybe<Array<RoleRequirement>>;
};

export type SubmissionError = Error & {
  __typename?: 'SubmissionError';
  message: Scalars['String']['output'];
};

export type SubmissionResult = Submission | SubmissionError;

export type UpdateStatusForProspectsPayload = {
  __typename?: 'UpdateStatusForProspectsPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateStatusForProspectsWithContextInput = {
  bucket: Bucket;
  positionId: Scalars['ID']['input'];
  prospectData: Array<ProspectData>;
  statusChangeLocation?: InputMaybe<Scalars['String']['input']>;
};

export type Verification = {
  __typename?: 'Verification';
  credentialInfo: Array<CredentialInfo>;
  title: Scalars['String']['output'];
};

export type WorkHistory = {
  __typename?: 'WorkHistory';
  achievements?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ProfileTextObject>;
  endDate?: Maybe<MonthYear>;
  id: Scalars['String']['output'];
  startDate: MonthYear;
  title?: Maybe<ProfileTextObject>;
};

export type WorkingWithChildrenCheckCredential = {
  __typename?: 'WorkingWithChildrenCheckCredential';
  fullName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  verification: CredentialVerification;
};
